import { Button, Image, Row, Space, Typography } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import './index.css';
import jump from '@/assets/layout/jump.svg';
import add from '@/assets/layout/add.png';
const { Text } = Typography;

const ChatFooterMobile = props => {
  const { content, onClick, style } = props;
  const { themeMode } = useSelector(state => state.global);
  const isNewChat = content === 'New Chat';
  // 根据 isNewChat 动态设置 src 属性
  const iconSrc = isNewChat ? add : jump;
  return (
    <div className={themeMode === 'dark' ? 'chat-footer-dark' : 'chat-footer'} style={style}>
      <Row justify="center">
        <Space size="large">
          <Text strong>{content}</Text>
          <Button
            size="large"
            type="primary"
            className="jump-btn"
            onClick={onClick}
            icon={<Image src={iconSrc} width={22} preview={false}></Image>}
          ></Button>
        </Space>
      </Row>
    </div>
  );
};

export default ChatFooterMobile;
